var _defs, _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCurrentLocation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 43.543,
    viewBox: "0 0 32 43.543",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#3b81d5}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5876",
    "data-name": "Group 5876",
    transform: "translate(-887.577 -540.48)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2437",
    "data-name": "Ellipse 2437",
    className: "cls-1",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(887.577 540.48)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2436",
    "data-name": "Ellipse 2436",
    transform: "translate(892.577 545.48)",
    style: {
      stroke: "#fff",
      fill: "#3b81d5"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10.5,
    style: {
      fill: "none"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_21862",
    "data-name": "Path 21862",
    className: "cls-1",
    d: "m902.268 581.662 9.911-14s-2.269 3.6-9.911 3.723-10.089-3.723-10.089-3.723z",
    transform: "translate(1.547 2.361)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentLocation);
export default __webpack_public_path__ + "static/media/current-location.39192af659ba3d7c36ad89a125bd2ffb.svg";
export { ForwardRef as ReactComponent };